import "./style.scss";
import $ from 'jquery';

$(document).ready(function () {
    $('.slider-cards-with-popups-multi-selector__item').on('click', function (event) {
        event.preventDefault();

        const selector = $('.slider-cards-with-popups-multi-selector__changer');
        const selectorPosition = $(this).attr("id");
        const tab = $(this).attr("tab");

        if (selectorPosition === "first-cards") {
            selector.addClass('slider-cards-with-popups-multi-selector__changer--left');
            selector.removeClass('slider-cards-with-popups-multi-selector__changer--right');
        } else {
            selector.addClass('slider-cards-with-popups-multi-selector__changer--right');
            selector.removeClass('slider-cards-with-popups-multi-selector__changer--left');
        }

        $('.slider-cards-with-popups-multi-selector__item').each(function () {
            $(this).removeClass("slider-cards-with-popups-multi-selector__item--active");
        });
        $(this).addClass("slider-cards-with-popups-multi-selector__item--active");

        $('.slider-cards-with-popups').each(function () {
            $(this).hide();
        })
        $(`#${tab}`).show();
        $('.slider-cards-with-popups.active-slider').slick('setPosition');
    })

    $('.slider-cards-with-popups-multi-selector__changer').on('click', function (event) {
        event.preventDefault();

        const firstCards = $('#first-cards');
        const secondCards = $('#second-cards');
        const firstTab = firstCards.attr("tab");
        const secondTab = secondCards.attr("tab");

        if ($(this).hasClass('slider-cards-with-popups-multi-selector__changer--right')) {
            $(this).removeClass('slider-cards-with-popups-multi-selector__changer--right');
            $(this).addClass('slider-cards-with-popups-multi-selector__changer--left');
            firstCards.addClass('slider-cards-with-popups-multi-selector__item--active');
            secondCards.removeClass('slider-cards-with-popups-multi-selector__item--active');
            $(`#${firstTab}`).show();
            $(`#${secondTab}`).hide();
        } else {
            $(this).removeClass('slider-cards-with-popups-multi-selector__changer--left');
            $(this).addClass('slider-cards-with-popups-multi-selector__changer--right');
            firstCards.removeClass('slider-cards-with-popups-multi-selector__item--active');
            secondCards.addClass('slider-cards-with-popups-multi-selector__item--active');
            $(`#${firstTab}`).hide();
            $(`#${secondTab}`).show();
        }

        $('.slider-cards-with-popups.active-slider').slick('setPosition');
    })

    $('.slider-cards-with-popups.active-slider').each(function () {
        const cardsSliderId = $(this).attr("id");
        activateSlider($(`#${cardsSliderId}`));
    });

    $('.slider-cards-with-popups-popups__slider').each(function () {
        const popupSliderId = $(this).attr("id");
        const popupSliderFooterId = $(this).next().attr("id");
        $(`#${popupSliderId}`).slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendArrows: $(`#${popupSliderFooterId}`),
            prevArrow: $(`#${popupSliderFooterId} .custom-slick-arrow-prev`),
            nextArrow: $(`#${popupSliderFooterId} .custom-slick-arrow-next`)
        });
    })

    $('.slider-cards-with-popups__popup-open').on('click', function (event) {
        event.preventDefault();

        const sliderId = $(this).attr("slider");
        const sliderFooterId = $(this).attr("slider-footer");
        const slider = $(`#${sliderId}`);
        const slides = $(`#${sliderId} .slider-cards-with-popups-popups__single`);
        const sliderFooter = $(`#${sliderFooterId}`);
        const popupNumber = $(this).attr("popup");

        $(this).closest('.slider-cards-with-popups').next().show();
        $('html').css('overflow-y', 'hidden');
        if (slides.length < 2) {
            slider.slick('destroy');
            sliderFooter.hide();
        } else {
            slider.slick('setPosition');
            slider.slick('slickGoTo', popupNumber, true);
        }
    });

    $('.slider-cards-with-popups-popups__close').on('click', function () {
        $(this).closest('.slider-cards-with-popups-popups').hide();
        $('html').css('overflow-y', 'auto');
    });

    // Response activate slider
    $('.slider-cards-with-popups').not('.active-slider').each(function () {
        const cardsSliderId = $(this).attr("id");
        const numOfBlocks = $(this).children().length;
        if (screen.width < 1050 && numOfBlocks > 3) {
            $(this).addClass('active-slider');
            activateSlider($(`#${cardsSliderId}`));
        } else if (screen.width < 781 && numOfBlocks > 2 && numOfBlocks < 4) {
            $(this).addClass('active-slider');
            activateSlider($(`#${cardsSliderId}`));
        } else {
            $(this).removeClass('active-slider');
            $(`#${cardsSliderId}`).slick('destroy');
        }
    });
});

function activateSlider(slider) {
    slider.slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        // dots: true,
        // dotsClass: 'slick-dots list-no-bullets'
        responsive: [
            {
                breakpoint: 1050,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 781,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 599,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
}